import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { BtnTitle, Wrapper } from './styles';

type HeaderButtonProps = {
  Icon?: React.FunctionComponent;
  component?: any;
  targetLocation?: string;
  activeText?: string;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
};

const HeaderButton = ({
  Icon,
  component,
  targetLocation,
  activeText,
  onClick,
}: HeaderButtonProps) => {
  const { pathname } = useLocation();

  const isActive = pathname === targetLocation;

  if (typeof onClick === 'function') {
    return (
      <Wrapper isActive={false} onClick={onClick}>
        {Icon && <Icon />}
        {component && component}
        {isActive && <BtnTitle>{activeText}</BtnTitle>}
      </Wrapper>
    );
  }

  return (
    <Link to={targetLocation || ''} style={{ textDecoration: 'none' }}>
      <Wrapper isActive={isActive}>
        {Icon && <Icon />}
        {component && component}
        {isActive && <BtnTitle>{activeText}</BtnTitle>}
      </Wrapper>
    </Link>
  );
};

export default HeaderButton;
